import React from "react";
import { Box, Typography, LinearProgress } from "@mui/material";
import styles from "../styles/CarePlanProgress.module.scss";
import { useTranslation } from "react-i18next";
import {
  GREEN_LIGHT,
  PRIMARY_GREEN,
} from "../../../utility/constants/common-constants";

interface Props {
  totalPoints: number;
  earnedPoints: number;
  completedCount: number;
  totalActivities: number;
  hideBorder?: boolean;
}

const CarePlanProgress: React.FC<Props> = ({
  totalPoints,
  earnedPoints,
  completedCount,
  totalActivities,
  hideBorder = false,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      className={`${styles.progressContainer} ${
        hideBorder ? styles.hideBorder : ""
      }`}
    >
      <Typography variant="subtitle2" mb={1} component="h5">
        <Typography variant="subtitle2" color="primary" component="span">
          {earnedPoints}
        </Typography>{" "}
        / {totalPoints} {t("carePlan.pointsLabel").toLowerCase()}
      </Typography>

      <LinearProgress
        variant="determinate"
        value={(earnedPoints / totalPoints) * 100}
        sx={{
          height: 10,
          borderRadius: 8,
          backgroundColor: "#F2F0EC",
          marginBottom: "8px",
          "& .MuiLinearProgress-bar": {
            borderRadius: 8,
            backgroundImage: `linear-gradient(90deg, ${GREEN_LIGHT}, ${PRIMARY_GREEN} )`,
          },
        }}
      />

      <Typography variant="body2" color="secondary.main">
        {t("carePlan.basedOn", {
          completed: completedCount,
          total: totalActivities,
        })}
      </Typography>
    </Box>
  );
};

export default CarePlanProgress;
